import config from '../config';
import { pico2ReferenceAreas } from './rules';

const lastBtuHR = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastBtuHRAvg = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastBtuHRCovar = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastHrBPM = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastCo2PPM = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastCo2PPMTimestamp = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastUpdatedBtuHR = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastUpdatedHrBPM = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastUpdatedCo2PPM = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const piCo2TimeByArea = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const nAveragedBtuHRs = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};
const lastSuitPressure = {
  NBL: {}, CHAPEA: {}, ARGOS: {}, FIELDTEST: {},
};

const minBtuHR = {};
const maxBtuHR = {};
const minHrBPM = {};
const maxHrBPM = {};

let metRateTimeoutId = null;
let heartRateTimeoutId = null;

function getPiCO2(btuHR) {
  return (4.353577 + (btuHR) * 0.003989).toFixed(2);
}

export default function WebsocketHelper() {
  const formatTimestamp = function formatTimestamp(date) {
    const hours = `${date.getHours()}`.padStart(2, '0');
    const minutes = `${date.getMinutes()}`.padStart(2, '0');
    const seconds = `${date.getSeconds()}`.padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };

  this.handleIncomingData = async function handleIncomingData(eventData, data, location) {
    const { timestamp } = eventData || {};
    const timestampDate = new Date(timestamp);

    const btuHR = eventData ? eventData.MetabolicRate_met_rate_btu_hr : null;
    const btuHRAvg = eventData ? eventData.mean : null;
    const btuHRCovar = eventData ? eventData.covariance : null;
    const co2mmHg = eventData && eventData.MetabolicRate_met_rate_btu_hr ? getPiCO2(eventData.MetabolicRate_met_rate_btu_hr) : null;
    const hrBPM = eventData ? eventData.hr_bpm : null;
    const evNum = eventData ? eventData.ev_num : null;
    const suitPressure = eventData && eventData.suit_pressure_psid != null ? eventData.suit_pressure_psid : null;
    const piCO2totals = eventData ? eventData.piCO2totals || {} : {};

    if (window.ipc && typeof window.ipc.send === 'function') {
      if (btuHR) {
        if (metRateTimeoutId) {
          clearTimeout(metRateTimeoutId);
        }
        metRateTimeoutId = setTimeout(() => {
          window.ipc.send('showDialog', {
            message: 'Met rate hasn\'t updated in the last minute.',
          });
        }, 60000);
      }
      if (hrBPM) {
        if (heartRateTimeoutId) {
          clearTimeout(heartRateTimeoutId);
        }
        heartRateTimeoutId = setTimeout(() => {
          window.ipc.send('showDialog', {
            message: 'Heart rate hasn\'t updated in the last minute.',
          });
        }, 60000);
      }
    }

    if (!nAveragedBtuHRs[location][evNum]) {
      nAveragedBtuHRs[location][evNum] = 0;
    }

    // set piCO2 totals so far (when replaying data)
    if (!piCo2TimeByArea[location][evNum]) {
      piCo2TimeByArea[location][evNum] = {};
    }
    pico2ReferenceAreas.forEach((area) => {
      const { legendValue, piCO2totalsKey } = area || {};
      if (piCo2TimeByArea[location][evNum][legendValue]) {
        piCo2TimeByArea[location][evNum][legendValue] += piCO2totals[piCO2totalsKey] || 0;
      } else {
        piCo2TimeByArea[location][evNum][legendValue] = piCO2totals[piCO2totalsKey] || 0;
      }
    });
    let timeDiff = null;

    lastSuitPressure[location][evNum] = suitPressure || lastSuitPressure[location][evNum] || null;
    lastBtuHR[location][evNum] = btuHR || lastBtuHR[location][evNum] || null;
    lastBtuHRAvg[location][evNum] = btuHRAvg || lastBtuHRAvg[location][evNum] || null;
    lastBtuHRCovar[location][evNum] = btuHRCovar || lastBtuHRCovar[location][evNum] || null;
    lastCo2PPM[location][evNum] = co2mmHg || lastCo2PPM[location][evNum] || null;
    lastHrBPM[location][evNum] = hrBPM || lastHrBPM[location][evNum] || null;

    if (btuHR) {
      lastUpdatedBtuHR[location][evNum] = timestampDate;
    }
    if (co2mmHg) {
      lastUpdatedCo2PPM[location][evNum] = timestampDate;
    }
    if (hrBPM) {
      lastUpdatedHrBPM[location][evNum] = timestampDate;
    }

    if (co2mmHg) {
      if (lastCo2PPMTimestamp[location][evNum]) {
        timeDiff = timestampDate - lastCo2PPMTimestamp[location][evNum];
        pico2ReferenceAreas.forEach((area) => {
          const { y1, legendValue } = area || {};
          if (parseFloat(lastCo2PPM[location][evNum]) > y1) {
            if (piCo2TimeByArea[location][evNum][legendValue]) {
              piCo2TimeByArea[location][evNum][legendValue] += timeDiff;
            } else {
              piCo2TimeByArea[location][evNum][legendValue] = timeDiff;
            }
          }
        });
      }
      lastCo2PPMTimestamp[location][evNum] = timestampDate;
    }

    if (!minBtuHR[location]) {
      minBtuHR[location] = btuHR;
    } else {
      minBtuHR[location] = Math.min(btuHR, minBtuHR[location]);
    }
    if (!maxBtuHR[location]) {
      maxBtuHR[location] = btuHR;
    } else {
      maxBtuHR[location] = Math.max(btuHR, maxBtuHR[location]);
    }
    if (!minHrBPM[location]) {
      minHrBPM[location] = hrBPM;
    } else {
      minHrBPM[location] = Math.min(hrBPM, minHrBPM[location]);
    }
    if (!maxHrBPM[location]) {
      maxHrBPM[location] = hrBPM;
    } else {
      maxHrBPM[location] = Math.max(hrBPM, maxHrBPM[location]);
    }

    const modifiedData = [...data];

    let date = new Date(timestamp);
    date = new Date(Math.round(date / config.CHART_RESOLUTION_MS) * config.CHART_RESOLUTION_MS);
    const formattedTimestamp = formatTimestamp(date);
    const indexMatch = data.findIndex((point) => point.formattedTimestamp === formattedTimestamp);

    const carryForward = (lastValues, lastUpdated, curLocation, curEvNum) => {
      const updatedAt = lastUpdated[curLocation] && lastUpdated[curLocation][curEvNum];
      if (!updatedAt || (timestampDate - updatedAt) > config.STALE_DATA_MS) {
        return null;
      }
      return lastValues[curLocation][curEvNum] || null;
    };

    if (indexMatch !== -1) {
      if (btuHR) {
        modifiedData[indexMatch][`${evNum}mr`] = btuHR;
      }
      if (btuHRAvg) {
        modifiedData[indexMatch][`${evNum}avgMr`] = btuHRAvg;
      }
      if (btuHRCovar) {
        modifiedData[indexMatch][`${evNum}covarMr`] = btuHRCovar;
      }
      if (hrBPM) {
        modifiedData[indexMatch][`${evNum}hr`] = hrBPM;
      }
      if (co2mmHg) {
        modifiedData[indexMatch][`${evNum}pico2`] = co2mmHg;
      }
    } else {
      const modifiedDataObject = { formattedTimestamp };
      Object.keys(lastBtuHR).forEach((curLocation) => {
        Object.keys(lastBtuHR[curLocation]).forEach((curEvNum) => {
          if (evNum === curEvNum && location === curLocation) {
            modifiedDataObject[`${curEvNum}mr`] = btuHR || carryForward(lastBtuHR, lastUpdatedBtuHR, location, curEvNum);
          } else {
            modifiedDataObject[`${curEvNum}mr`] = carryForward(lastBtuHR, lastUpdatedBtuHR, curLocation, curEvNum);
          }
        });
      });
      Object.keys(lastBtuHRAvg).forEach((curLocation) => {
        Object.keys(lastBtuHRAvg[curLocation]).forEach((curEvNum) => {
          if (evNum === curEvNum && location === curLocation) {
            modifiedDataObject[`${curEvNum}avgMr`] = btuHRAvg || carryForward(lastBtuHRAvg, lastUpdatedBtuHR, location, curEvNum);
          } else {
            modifiedDataObject[`${curEvNum}avgMr`] = carryForward(lastBtuHRAvg, lastUpdatedBtuHR, curLocation, curEvNum);
          }
        });
      });
      Object.keys(lastBtuHRCovar).forEach((curLocation) => {
        Object.keys(lastBtuHRCovar[curLocation]).forEach((curEvNum) => {
          if (evNum === curEvNum && location === curLocation) {
            modifiedDataObject[`${curEvNum}covarMr`] = btuHRCovar || carryForward(lastBtuHRCovar, lastUpdatedBtuHR, location, curEvNum);
          } else {
            modifiedDataObject[`${curEvNum}covarMr`] = carryForward(lastBtuHRCovar, lastUpdatedBtuHR, curLocation, curEvNum);
          }
        });
      });
      Object.keys(lastHrBPM).forEach((curLocation) => {
        Object.keys(lastHrBPM[curLocation]).forEach((curEvNum) => {
          if (evNum === curEvNum && location === curLocation) {
            modifiedDataObject[`${curEvNum}hr`] = hrBPM || carryForward(lastHrBPM, lastUpdatedHrBPM, location, curEvNum);
          } else {
            modifiedDataObject[`${curEvNum}hr`] = carryForward(lastHrBPM, lastUpdatedHrBPM, curLocation, curEvNum);
          }
        });
      });
      Object.keys(lastCo2PPM).forEach((curLocation) => {
        Object.keys(lastCo2PPM[curLocation]).forEach((curEvNum) => {
          if (evNum === curEvNum && location === curLocation) {
            modifiedDataObject[`${curEvNum}pico2`] = co2mmHg || carryForward(lastCo2PPM, lastUpdatedCo2PPM, location, curEvNum);
          } else {
            modifiedDataObject[`${curEvNum}pico2`] = carryForward(lastCo2PPM, lastUpdatedCo2PPM, curLocation, curEvNum);
          }
        });
      });
      modifiedData.push(modifiedDataObject);
    }
    const suitPressureByEv = {};
    Object.keys(lastSuitPressure[location]).forEach((ev) => {
      if (lastSuitPressure[location][ev] != null) {
        suitPressureByEv[ev] = lastSuitPressure[location][ev];
      }
    });

    return {
      data: modifiedData.sort((a, b) => {
        const { formattedTimestamp: aTime } = a || {};
        const { formattedTimestamp: bTime } = b || {};
        return aTime > bTime ? 1 : -1;
      }),
      minBtuHR: minBtuHR[location],
      maxBtuHR: maxBtuHR[location],
      minHrBPM: minHrBPM[location],
      maxHrBPM: maxHrBPM[location],
      piCo2TimeByArea: piCo2TimeByArea[location],
      suitPressure: suitPressureByEv,
    };
  };

  this.handleHMDEvent = function handleHMDEvent(eventData, data) {
    return new Promise((resolve) => {
      const {
        Action, ClientOrigin, Display, Line1Text, Line2Text, Line3Text, MaxMetRate, MaxStateListLength,
        ScreenRotation, ThingName, Timestamp,
      } = eventData || {};

      const action = typeof Action === 'string' ? Action.toUpperCase() : '';
      const clientOrigin = typeof ClientOrigin === 'string' ? ClientOrigin.toUpperCase() : '';
      const display = typeof Display === 'string' ? Display.toUpperCase() : '';
      const line1Text = typeof Line1Text === 'string' ? Line1Text.toUpperCase() : '';
      const line2Text = typeof Line2Text === 'string' ? Line2Text.toUpperCase() : '';
      const line3Text = typeof Line3Text === 'string' ? Line3Text.toUpperCase() : '';
      const maxMetRate = typeof MaxMetRate === 'string' ? MaxMetRate.toUpperCase() : '';
      const maxStateListLength = typeof MaxStateListLength === 'string' ? MaxStateListLength.toUpperCase() : '';
      const screenRotation = typeof ScreenRotation === 'string' ? ScreenRotation.toUpperCase() : '';
      const thingName = typeof ThingName === 'string' ? ThingName.toUpperCase() : '';

      const date = new Date(Timestamp);
      const timestamp = formatTimestamp(date);

      resolve([...data, {
        action,
        clientOrigin,
        display,
        line1Text,
        line2Text,
        line3Text,
        maxMetRate,
        maxStateListLength,
        screenRotation,
        thingName,
        timestamp,
      }]);
    });
  };

  this.handleMaestroEvent = function handleMaestroEvent(eventData, data) {
    return new Promise((resolve) => {
      const {
        EVNum: evNumRaw,
        Location: locationRaw,
        ProcedureName: procNameRaw,
        StepType: stepRaw,
        StepContent: contentRaw,
        StepStatus: statusRaw,
        Timestamp: timestampRaw,
        TagList: tagsRaw,
        MaestroStepUuid: uuidRaw,
      } = eventData || {};

      const evNum = evNumRaw?.toUpperCase() || '';
      const location = locationRaw?.toUpperCase() || '';
      const procedure = procNameRaw?.toUpperCase() || '';
      const activity = stepRaw?.toUpperCase() || '';
      const step = contentRaw?.toUpperCase() || '';
      const status = statusRaw?.toUpperCase() || '';
      const tags = JSON.stringify((tagsRaw || []).join(', ').toUpperCase());
      const uuid = uuidRaw?.toUpperCase() || '';

      const date = new Date(parseInt(timestampRaw, config.PARSE_INT_BASE));
      const timestamp = formatTimestamp(date);

      resolve([...data, {
        evNum, location, procedure, activity, step, status, timestamp, tags, uuid,
      }]);
    });
  };

  this.handleECSEvent = function handleECSEvent(eventData, data) {
    return new Promise((resolve) => {
      const {
        WaterSupplyTemp: waterSupplyTemp,
        ReturnGasFlowSCFM: returnGasFlowScfm,
        SuitActualPressure: suitActualPressure,
        SuitAmbientPressure: suitAmbientPressure,
        SuitDeltaPressure: suitDeltaPressure,
        SupplyGasFlowSCFM: supplyGasFlowScfm,
        TestStartTime: testStartTime,
        TotalGasOnTimeInSEC: totalGasOnTimeInSec,
        CoolingFlow: coolingFlow,
        EmuDepth: emuDepth,
        EventType: eventType,
        umbilical_color: umbilicalColor,
        timestamp,
      } = eventData || {};

      resolve([...data, {
        coolingFlow: parseInt(coolingFlow, config.PARSE_INT_BASE),
        emuDepth: parseInt(emuDepth, config.PARSE_INT_BASE),
        totalGasOnTimeInSec: parseInt(totalGasOnTimeInSec, config.PARSE_INT_BASE),
        waterSupplyTemp: parseInt(waterSupplyTemp, config.PARSE_INT_BASE),
        returnGasFlowScfm: parseInt(returnGasFlowScfm, config.PARSE_INT_BASE),
        suitActualPressure: parseInt(suitActualPressure, config.PARSE_INT_BASE),
        suitAmbientPressure: parseInt(suitAmbientPressure, config.PARSE_INT_BASE),
        suitDeltaPressure: parseInt(suitDeltaPressure, config.PARSE_INT_BASE),
        supplyGasFlowScfm: parseInt(supplyGasFlowScfm, config.PARSE_INT_BASE),
        testStartTime,
        eventType,
        umbilicalColor,
        timestamp: formatTimestamp(new Date(timestamp)),
      }]);
    });
  };
}
